// AM-028 §2.2 — این کامپوننت جایگزین لیست خام قبلی WorkInstructionPage.tsx
// می‌شود. برای اپراتور، فقط اکتیو /work-instructions/active/ را می‌خواند.
// برای سرپرست، prop `productionLineId` پاس داده می‌شود تا از
// /work-instructions/for_line/ استفاده کند.
//
// VERIFY AGAINST repo: نام دقیق hook بعد از اجرای orval.
import {
  useV1ProductionShopfloorWorkInstructionsActiveRetrieve as useShopfloorActiveWorkInstructions,
  useV1ProductionShopfloorWorkInstructionsForLineRetrieve as useShopfloorLineWorkInstructions,
} from "../../api/generated/v1/v1";

interface ActiveWorkInstructionsPanelProps {
  /** اگر تعیین شود، حالت سرپرست/مدیر (نمایش کل خط)؛ در غیر این صورت حالت اپراتور. */
  productionLineId?: string;
}

export function ActiveWorkInstructionsPanel({
  productionLineId,
}: ActiveWorkInstructionsPanelProps) {
  const operatorQuery = useShopfloorActiveWorkInstructions({
    query: { enabled: !productionLineId },
  });
  const lineQuery = useShopfloorLineWorkInstructions(
    { production_line: productionLineId as string },
    { query: { enabled: Boolean(productionLineId) } }
  );

  const { data, isLoading, isError } = (productionLineId ? lineQuery : operatorQuery) as any;

  if (isLoading) {
    return <div className="p-4 text-sm text-gray-500">در حال بارگذاری دستورالعمل‌ها...</div>;
  }

  if (isError) {
    return (
      <div className="p-4 text-sm text-red-600">
        خطا در دریافت دستورالعمل‌ها. اگر سرپرست این خط نیستید، دسترسی ندارید.
      </div>
    );
  }

  const instructions = data?.data ?? data ?? [];

  if (!instructions.length) {
    return (
      <div className="p-6 text-center text-sm text-gray-500 border rounded-lg">
        در حال حاضر دستورالعملی برای ایستگاه(های) فعال شما ثبت نشده است.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {instructions.map((item: any) => (
        <div key={item.work_order_id + item.work_instruction_family_code} className="border rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <h4 className="font-semibold">{item.title}</h4>
            <span className="text-xs text-gray-400">نسخه {item.revision_no}</span>
          </div>
          <p className="text-sm whitespace-pre-wrap">{item.content}</p>
          {item.attachment_url && (
            <a
              href={item.attachment_url}
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 text-sm underline mt-2 inline-block"
            >
              پیوست
            </a>
          )}
        </div>
      ))}
    </div>
  );
}

export default ActiveWorkInstructionsPanel;
